import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import axios from 'axios';

import { useLanguage } from '../contexts/LanguageContext';
import { useResto } from '../contexts/RestoContext';
import { setFlashMessage } from '../contexts/WebsiteContext';
import config from '../config/config';

const MenusLight = () => {
  const { t } = useTranslation();
  const { activeLanguage } = useLanguage();
  const { restoData } = useResto();

  const { apiUrl } = config;
  const apiPath = `${apiUrl}menu`;

  const [menusByLanguage, setMenusByLanguage] = useState({});

  const fetchItems = async () => {
    if (!restoData?.website) return;

    try {
      const response = await axios.get(
        `${apiPath}?website=${restoData.website}`
      );

      const menus = Array.isArray(response.data)
        ? response.data
        : [];

      const grouped = {};

      menus.forEach(menu => {
        if (!grouped[menu.language]) {
          grouped[menu.language] = [];
        }
        grouped[menu.language].push(menu);
      });

      setMenusByLanguage(grouped);

    } catch {
      setFlashMessage(
        t('ERROR_MESSAGE'),
        'error'
      );
    }
  };

  useEffect(() => {
    fetchItems();
  }, [restoData?.website]);

  const currentMenus =
    menusByLanguage[activeLanguage] || [];

  return (
    <div
      className="d-flex justify-content-center background-main-color-60"
      style={{
        color: '#fff',
        padding: '5px 0'
      }}
    >
      {currentMenus.map(menu => (
        <a
          key={menu.id}
          href={`${config.documentsUrl}menus/${menu.filename}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ margin: '0 5px' }}
        >
          <Button variant="primary">
            {menu.label}
          </Button>
        </a>
      ))}
    </div>
  );
};

export default MenusLight;